// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"Accordion_componentStyle__9o6mp"};